<!-- 面试管理 -->
<template>
  <div class="result-box">
    <!-- 列表 -->
    <van-nav-bar title="牛人收藏" fixed placeholder z-index="10" @click-left="onClickLeft">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <div class="status-all" v-for="(item, index) in list" :key="index">
          <div class="user-box" @click="goResume(item.resume_id)">
            <div>
              <div class="user-name">{{item.name}}</div>
              <div class="user-position">
                <span v-if="item.soldier_type_name!=''">{{item.soldier_type_name}}</span>
                <span v-if="item.soldier_type_name!=''">{{item.education_name}}</span>
                <span>{{arr[index]+1}}岁</span>
              </div>
              <div class="user-icon">
                <span>{{item.job_intent}}</span>
                <span>{{item.job_wage}}</span>
              </div>
            </div>
            <img :src="item.avatar" class="head-img" />
          </div>
          <div class="user-description">
            <div class="user-text">{{item.description==null?'还没有添加个人简介~':item.description}}</div>
            <!-- <van-icon
              :name="item.is_collect?'star':'star-o'"
              size="30"
              color="#FF6F00"
              @click="collect([item.resume_id,item.is_collect])"
            />-->
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { tjList } from "@/api/apiData";
export default {
  components: {},
  data() {
    return {
      page: 0,
      totalPages: 1,
      list: [],
      offset: 10,
      loading: false,
      finished: false,
      refreshing: false,
      arr: [],
      is_recommend: 1,
      is_latest: ""
    };
  },
  computed: {},
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    // 上拉加载
    onLoad() {
      var that = this;
      that.getList();
    },
    // 下拉刷新
    onRefresh() {
      var that = this;
      that.totalPages = 1;
      that.page = 0;
      that.loading = false;
      that.finished = false;
      that.list = [];
      that.getList();
      setTimeout(() => {
        that.refreshing = false;
      }, 1500);
    },
    //获取推荐列表
    getList() {
      var that = this;
      let { page, totalPages, list, offset } = that;
      let obj = {
        page: page + 1,
        offset: offset,
        is_collect: 1
        // is_recommend: is_recommend
        // is_latest: is_latest
        // education:education,
        // experience:experience,
        // min_salary:min_salary,
        // max_salary:max_salary,
        // soldier_type:soldier_type
      };
      that.loading = true;
      if (totalPages > page) {
        tjList(obj).then(res => {
          //(res);
          if (res.code == 1) {
            that.list = list.concat(res.data.list);
            that.page = page + 1;
            that.totalPages = Math.ceil(Number(res.data.total) / offset);
            if (res.data.list.length == 0) {
              setTimeout(() => {
                that.finished = true;
                that.loading = false;
              }, 1500);
              return false;
            }
            if (that.list.length > list.length) {
              that.list.forEach(item => {
                var birthday = item.birthday;
                var index = birthday.indexOf("-");
                var date = birthday.substring(0, index);
                var nowDate = new Date();
                var Y = nowDate.getFullYear();
                var age = Y - Number(date);
                that.arr.push(age);
              });
              setTimeout(() => {
                that.loading = false;
              }, 1500);
            }
          } else {
            Toast(res.msg);
          }
        });
      } else {
        that.finished = true;
        that.loading = false;
      }
    },
    // 查看简历
    goResume(id) {
      var that = this;
      that.$router.push({
        name: "resumeDetails",
        query: {
          id: id
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getList();
  }
};
</script>
<style lang='less' scoped>
.result-box {
  background: #f7f7f7;
  // 全部
  .status-all {
    // display: flex;
    // align-items: center;
    padding: 0.36rem 0.32rem;
    margin-bottom: 0.2rem;
    // justify-content: space-between;
    background: #fff;
    .head-img {
      width: 1.18rem;
      height: 1.18rem;
      border-radius: 50%;
      align-self: flex-start;
    }
    .user-box {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .user-name {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.36rem;
        font-weight: bold;
        line-height: 0.42rem;
        color: #333;
        // span:last-child {
        //   font-size: 0.26rem;
        //   font-weight: 400;
        //   line-height: 0.37rem;
        //   color: rgba(102, 102, 102, 1);
        // }
      }
      .user-icon {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(128, 128, 128, 1);
        position: relative;
        span {
          padding: 0.02rem 0.04rem;
          border-radius: 0.04rem;
          background: rgba(247, 247, 247, 1);
          font-size: 0.2rem;
          font-weight: 400;
          line-height: 0.28rem;
          color: rgba(128, 128, 128, 1);
          margin: 0.08rem 0.12rem 0.08rem 0;
        }
        //   p {
        //     position: absolute;
        //     right: 0;
        //     font-size: 0.28rem;

        //     font-weight: bold;
        //     line-height: 0.4rem;
        //     color: rgba(51, 51, 51, 1);
        //   }
      }
      .user-position {
        display: flex;
        align-items: center;
        position: relative;
        margin: 0.2rem 0;
        span {
          font-size: 0.24rem;
          font-weight: 400;
          line-height: 0.33rem;
          color: rgba(51, 51, 51, 1);
          display: flex;
          align-items: center;
        }
        span::after {
          content: "";
          display: block;
          height: 0.25rem;
          width: 0.02rem;
          background: rgba(178, 178, 178, 0.8);
          margin: 0 0.2rem;
        }
        span:last-child::after {
          display: none;
        }
        //   p {
        //     position: absolute;
        //     right: 0;
        //     font-size: 0.24rem;
        //     font-weight: 400;
        //     line-height: 0.33rem;
        //     color: rgba(128, 128, 128, 1);
        //   }
      }
    }
    .user-description {
      display: flex;
      justify-content: space-between;
      margin-top: 0.1rem;
      .user-text {
        width: 80%;
        font-size: 0.26rem;
        font-weight: 500;
        line-height: 1.5;
        color: #333333;
      }
      .van-icon {
        display: flex;
        justify-content: flex-end;
      }
      .van-icon::before {
        align-self: flex-end;
        padding-bottom: 0.1rem;
      }
    }
  }
}
</style>